import classNames from 'classnames';
import React from 'react';

export function StickyBottomBar({ children, className }: React.PropsWithChildren<{ className?: string }>) {
    return (
        <div
            className={classNames(
                'sticky bottom-0 mt-8 flex flex-row gap-3 border-t bg-white p-4 lg:static',
                className
            )}
        >
            {children}
        </div>
    );
}
